<template>
    <div v-if="statistics">

        <h4> Record </h4>
        <div v-if="statistics.record">
            <table class="table">
                <th v-if="propertyName != 'games_played' && propertyName != 'extra_points' && propertyName != 'efficiency'" v-for="(value, propertyName) in statistics.record">
                    {{ propertyName }}
                </th>

                <tr>
                    <td  v-if="propertyName != 'games_played' && propertyName != 'extra_points' && propertyName != 'efficiency'"  v-for="(value, propertyName) in statistics.record">
                        <div v-for="(value2, propertyName2) in value">
                            {{ propertyName2 }}: {{ value2 }} </br>
                        </div>    
                    </td>
                </tr>
            </table>
        </div>
        <h4> Opponents </h4>
        <div v-if="statistics.opponents">
        <table class="table">
                <th v-if="propertyName != 'games_played' && propertyName != 'extra_points' && propertyName != 'efficiency'" v-for="(value, propertyName) in statistics.opponents">
                    {{ propertyName }}
                </th>

                <tr>
                    <td  v-if="propertyName != 'games_played' && propertyName != 'extra_points' && propertyName != 'efficiency'"  v-for="(value, propertyName) in statistics.opponents">
                        <div v-for="(value2, propertyName2) in value">
                            {{ propertyName2 }}: {{ value2 }} </br>
                        </div>    
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="statistics.players">
            <h4>players</h4>

            <table class="table">
                <tr>
                    <th>name</th>
                    <th>position</th>
                    <th>penalties</th>
                    <th>fumbles</th>
                    <th>defense</th>
                    <th>receiving</th>
                    <th>rushing</th>
                    <th>passing</th>
                    

                </tr>
                <tr v-for="player in statistics.players">
                    <td>{{ player.name }}</td>
                    <td>{{ player.position }}</td>
                    <td>
                        <div v-for="(value, propertyName) in player.penalties">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                    <td>
                        <div v-for="(value, propertyName) in player.fumbles">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                    <td>
                        <div v-for="(value, propertyName) in player.defense">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                    <td>
                        <div v-for="(value, propertyName) in player.receiving">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                    <td>
                        <div v-for="(value, propertyName) in player.rushing">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                    <td>
                        <div v-for="(value, propertyName) in player.passing">
                            {{propertyName}}: {{value}} </br>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'NFLSeasonalStatistics',
    props: {
        statistics: '',
    },
    data: function() {
        return {            
            
        }
    }, 
}
</script>

